var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0963 14.1445H7.07959C6.73459 14.1445 6.45459 13.8645 6.45459 13.5195C6.45459 13.1745 6.73459 12.8945 7.07959 12.8945H13.0963C13.4413 12.8945 13.7213 13.1745 13.7213 13.5195C13.7213 13.8645 13.4413 14.1445 13.0963 14.1445Z",
    fill: "url(#paint0_linear_1798_40845)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0963 10.6562H7.07959C6.73459 10.6562 6.45459 10.3762 6.45459 10.0312C6.45459 9.68625 6.73459 9.40625 7.07959 9.40625H13.0963C13.4413 9.40625 13.7213 9.68625 13.7213 10.0312C13.7213 10.3762 13.4413 10.6562 13.0963 10.6562Z",
    fill: "url(#paint1_linear_1798_40845)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37542 7.17578H7.07959C6.73459 7.17578 6.45459 6.89578 6.45459 6.55078C6.45459 6.20578 6.73459 5.92578 7.07959 5.92578H9.37542C9.72042 5.92578 10.0004 6.20578 10.0004 6.55078C10.0004 6.89578 9.72042 7.17578 9.37542 7.17578Z",
    fill: "url(#paint2_linear_1798_40845)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1798_40845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 16,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1.66797H17.6372V18.2595H2.5V1.66797Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1798_40845)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.257 2.91797L6.84951 2.9213C4.90951 2.93297 3.74951 4.13297 3.74951 6.13214V13.7955C3.74951 15.808 4.92035 17.0096 6.87951 17.0096L13.287 17.0071C15.227 16.9955 16.387 15.7938 16.387 13.7955V6.13214C16.387 4.11964 15.217 2.91797 13.257 2.91797ZM6.88034 18.2596C4.26034 18.2596 2.49951 16.4655 2.49951 13.7955V6.13214C2.49951 3.43797 4.20535 1.68714 6.84535 1.6713L13.2562 1.66797H13.257C15.877 1.66797 17.637 3.46214 17.637 6.13214V13.7955C17.637 16.4888 15.9312 18.2405 13.2912 18.2571L6.88034 18.2596Z",
    fill: "url(#paint3_linear_1798_40845)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40845",
    x1: 10.0879,
    y1: 12.8945,
    x2: 10.0879,
    y2: 14.1445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB54E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40845",
    x1: 10.0879,
    y1: 9.40625,
    x2: 10.0879,
    y2: 10.6562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB54E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1798_40845",
    x1: 8.22751,
    y1: 5.92578,
    x2: 8.22751,
    y2: 7.17578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB54E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1798_40845",
    x1: 10.0683,
    y1: 1.66797,
    x2: 10.0683,
    y2: 18.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB54E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasesIcon);
export default __webpack_public_path__ + "static/media/cases-icon.ce93a2d5ded6416532284d982472b564.svg";
export { ForwardRef as ReactComponent };